module.exports = __webpack_public_path__ + "img/website_pic_2@3x.4df97cf5.png";